var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoGreenGreyinline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 193.066,
    height: 46.071,
    viewBox: "0 0 122.292 29.182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_green_grey_menu",
    transform: "translate(-784.16 945)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(784.16 -945)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M190.715,111.833v.006a2.927,2.927,0,0,0-2.73-2.758,2.889,2.889,0,0,0-2.108.74,6.9,6.9,0,0,1-1.857,1v-7.187a5.255,5.255,0,0,0-5.255-5.255H171.29a6.5,6.5,0,0,1-3.263-1.308,2.9,2.9,0,1,0-.242,4.516l-.009.014.042-.037c.065-.049.128-.1.189-.153a6.3,6.3,0,0,1,3.711-1.343h.484v-.018h6.568a3.589,3.589,0,0,1,3.589,3.589v7.5h-.014v.006H168.627a4.052,4.052,0,0,0-4.052,4.052v5.889a4.449,4.449,0,0,0,1.032,2.889,4.322,4.322,0,0,0,3.31,1.531H170.8l8.7-.051a4.56,4.56,0,0,0,4.523-4.543v-7.784a6.911,6.911,0,0,1,1.877,1.02c.061.054.128.1.189.153l.042.037-.009-.014a2.9,2.9,0,0,0,4.594-2.5ZM167.307,99.478a1.237,1.237,0,1,1,0-.494A1.239,1.239,0,0,1,167.307,99.478ZM179.489,123.8l-9.061.045a12.945,12.945,0,0,1-2.732-.283,2.694,2.694,0,0,1-1.454-2.388V115.2a2.384,2.384,0,0,1,2.384-2.384h13.717v.011h.01v8.093A2.889,2.889,0,0,1,179.489,123.8Zm8.574-10.6a1.24,1.24,0,1,1,.967-1.457A1.236,1.236,0,0,1,188.063,113.2Z",
    transform: "translate(-163.16 -96.33)",
    fill: "#1abb9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M313.49,225.581v1.231a2.884,2.884,0,0,1,1.676-.914s0-.006,0-.01A5.5,5.5,0,0,0,313.49,225.581Z",
    transform: "translate(-294.305 -209.086)",
    fill: "#108972"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(819.978 -940.694)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M81.977,368.779a3.134,3.134,0,0,0-1.2-.771,5.01,5.01,0,0,0-1.747-.27h-6.59v2.121H79a1.661,1.661,0,0,1,1.3.436,1.576,1.576,0,0,1,.386,1.08v.833h-5.2a5.915,5.915,0,0,0-1.728.22,2.916,2.916,0,0,0-1.157.625,2.362,2.362,0,0,0-.632.987,4.129,4.129,0,0,0-.2,1.33,3.382,3.382,0,0,0,.856,2.464,3.787,3.787,0,0,0,2.819.895H80.6a4.3,4.3,0,0,0,1.134-.123,1.5,1.5,0,0,0,.7-.386,1.389,1.389,0,0,0,.343-.675,4.726,4.726,0,0,0,.093-1.018v-5.159a4.81,4.81,0,0,0-.208-1.434A2.892,2.892,0,0,0,81.977,368.779Zm-1.28,7.246q0,.563-.6.563H75.468a1.6,1.6,0,0,1-1.184-.363,1.326,1.326,0,0,1-.355-.968,1.258,1.258,0,0,1,.355-.945,1.743,1.743,0,0,1,1.226-.343H80.7Z",
    transform: "translate(-71.763 -362.987)",
    fill: "#9b9b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M115.6,367.761h-3.031a3.8,3.8,0,0,0-3.015,1.157,5.291,5.291,0,0,0-1.022,3.559v10.685h2.2v-4.423H115.6a4.539,4.539,0,0,0,3.47-1.35,7.308,7.308,0,0,0,0-8.264A4.518,4.518,0,0,0,115.6,367.761Zm1.862,8.055a2.6,2.6,0,0,1-2.09.771h-4.627v-4.026a3.045,3.045,0,0,1,.563-2.059,2.5,2.5,0,0,1,1.928-.625H115.4a2.6,2.6,0,0,1,2.09.771,3.994,3.994,0,0,1,.656,2.58,4.142,4.142,0,0,1-.686,2.587Z",
    transform: "translate(-94.352 -362.998)",
    fill: "#9b9b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M146.625,368.537a3.638,3.638,0,0,0-.675,2.433v7.778h2.2v-7.442a1.251,1.251,0,0,1,1.415-1.415h3.856V367.77h-4.512A2.918,2.918,0,0,0,146.625,368.537Z",
    transform: "translate(-117.343 -363.008)",
    fill: "#9b9b9b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 2.225,
    height: 2.557,
    transform: "translate(38.251 0.625)",
    fill: "#9b9b9b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 2.202,
    height: 10.978,
    transform: "translate(38.251 4.762)",
    fill: "#9b9b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M192.86,373.232a3.028,3.028,0,0,0-1.157-.667,5.976,5.976,0,0,0-1.882-.251h-2.58a1.854,1.854,0,0,1-1.238-.3,1.156,1.156,0,0,1-.324-.883,1.223,1.223,0,0,1,.332-.937,1.586,1.586,0,0,1,1.1-.312h6.069V367.76h-6.093a3.661,3.661,0,0,0-2.746.864,3.228,3.228,0,0,0-.833,2.341,4.346,4.346,0,0,0,.166,1.207,2.436,2.436,0,0,0,.594,1.03,2.915,2.915,0,0,0,1.157.706,5.65,5.65,0,0,0,1.87.258h2.6a1.983,1.983,0,0,1,1.2.281,1.121,1.121,0,0,1,.362.945,1.158,1.158,0,0,1-.332.926,1.713,1.713,0,0,1-1.1.281H183.64v2.14h6.382a4.815,4.815,0,0,0,1.643-.251,3.016,3.016,0,0,0,1.122-.686,2.579,2.579,0,0,0,.632-1.049,4.372,4.372,0,0,0,.2-1.342,4.245,4.245,0,0,0-.166-1.207A2.232,2.232,0,0,0,192.86,373.232Z",
    transform: "translate(-140.418 -363.002)",
    fill: "#9b9b9b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 2.225,
    height: 2.557,
    transform: "translate(55.8 0.625)",
    fill: "#9b9b9b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 2.202,
    height: 10.978,
    transform: "translate(55.8 4.762)",
    fill: "#9b9b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M238.617,360.182h-4.843a4.566,4.566,0,0,0-3.47,1.35,5.769,5.769,0,0,0-1.3,4.138,5.836,5.836,0,0,0,1.28,4.138,4.566,4.566,0,0,0,3.47,1.35h3.035a3.811,3.811,0,0,0,3-1.157,5.209,5.209,0,0,0,1.03-3.544V355.42h-2.225Zm0,6.17a2.993,2.993,0,0,1-.563,2.036,2.469,2.469,0,0,1-1.893.625h-2.183a2.6,2.6,0,0,1-2.09-.771,3.965,3.965,0,0,1-.652-2.572,4.044,4.044,0,0,1,.656-2.58,2.517,2.517,0,0,1,2.09-.771h4.627Z",
    transform: "translate(-168.368 -355.42)",
    fill: "#9b9b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M274.623,374.3a4.065,4.065,0,0,0,2.869-.821,3.084,3.084,0,0,0,.856-2.341,3.382,3.382,0,0,0-.872-2.483,3.847,3.847,0,0,0-2.826-.883h-3.555a5.021,5.021,0,0,0-1.758.27,3.149,3.149,0,0,0-1.184.771,2.894,2.894,0,0,0-.675,1.157,4.782,4.782,0,0,0-.208,1.434v3.744a4.762,4.762,0,0,0,.208,1.446,2.9,2.9,0,0,0,.675,1.157,3.141,3.141,0,0,0,1.184.771,5.018,5.018,0,0,0,1.758.27h6.717v-2.14h-6.721a1.682,1.682,0,0,1-1.3-.428,1.566,1.566,0,0,1-.386-1.091v-.771Zm-5.217-2.888a1.576,1.576,0,0,1,.386-1.08,1.658,1.658,0,0,1,1.3-.436h3.536a1.624,1.624,0,0,1,1.184.386,1.35,1.35,0,0,1,.386,1,1.274,1.274,0,0,1-.362.956,1.783,1.783,0,0,1-1.257.355h-5.171Z",
    transform: "translate(-191.881 -363.005)",
    fill: "#9b9b9b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGreenGreyinline);
export default __webpack_public_path__ + "static/media/logo_green_grey.inline.08403bb916b1bfcb40b4d356ebb6b4f4.svg";
export { ForwardRef as ReactComponent };